import en from './en.json';
import zh from './zh.json';
import ru from './ru.json';
import zhtw from './zh-tw.json';
import ar from './ar.json';
import my from './my.json';
import id from './id.json';
import tr from './tr.json';
import tkm from './tkm.json';
export default {
  en,
  zh,
  ru,
  zhtw,
  ar,
  my,
  id,
  tr,
  tkm,
};
